
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";

export default defineComponent({
  name: "line-tabs-2x",
  components: {
    CodeHighlighter
  }
});
